<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group>
      <mat-tab label="Permissions List">
        <ng-template matTabContent>
          <div class="p-3">
            <mat-accordion>
              <mat-expansion-panel
                *ngFor="let permission of permissionData"
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ permission.name }}
                  </mat-panel-title>
                  <mat-panel-description>
                    Order: {{ permission.selection_order }}
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <p class="permission-data">Permissions Data</p>

                <mat-table
                  [dataSource]="permission.permissions"
                  class="mat-elevation-z8"
                  style="width: 100%">
                  <!-- Title Column -->
                  <ng-container matColumnDef="title">
                    <mat-header-cell *matHeaderCellDef> Title </mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="Title">
                      {{ element.title }}
                    </mat-cell>
                  </ng-container>

                  <!-- Slug Column -->
                  <ng-container matColumnDef="slug">
                    <mat-header-cell *matHeaderCellDef> Slug </mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="Slug">
                      {{ element.slug }}
                    </mat-cell>
                  </ng-container>

                  <!-- Permission Type Column -->
                  <ng-container matColumnDef="permission_type">
                    <mat-header-cell *matHeaderCellDef>
                      Permission Type
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      data-label="Permission Type">
                      <ng-container *ngIf="element.permission_type === 'url'">
                        URL
                      </ng-container>
                      <ng-container
                        *ngIf="element.permission_type === 'clickAction'">
                        Click Action
                      </ng-container>
                      <ng-container
                        *ngIf="element.permission_type === 'apiData'">
                        API Data
                      </ng-container>
                    </mat-cell>
                  </ng-container>

                  <!-- In Menu Column -->
                  <ng-container matColumnDef="display_in_menu">
                    <mat-header-cell *matHeaderCellDef>
                      In Menu
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="In Menu">
                      <mat-icon
                        *ngIf="!element.display_in_menu"
                        class="active-icon red-500 s-16">
                        close
                      </mat-icon>
                      <mat-icon
                        *ngIf="element.display_in_menu"
                        class="active-icon green-600 s-16">
                        check
                      </mat-icon>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row
                    *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row
                    *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
                <mat-action-row class="btn-group pe-4">
                  <a
                    mat-button
                    color="primary"
                    [routerLink]="[
                      '/user-management/permission/edit',
                      permission.permission_section_id,
                    ]"
                    *appHasAccess="'/user-management/permission/edit/:id'">
                    EDIT
                  </a>
                  <button
                    mat-button
                    color="warn"
                    (click)="onDelete(permission.permission_section_id)"
                    *appHasAccess="'delete-permission'">
                    DELETE
                  </button>
                </mat-action-row>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *appHasAccess="'/user-management/permission/add'">
        <ng-template mat-tab-label>
          <a
            class="btn primary-btn"
            [routerLink]="['/user-management/permission/add']">
            Add Permission
          </a>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
